package com.zi.support.shared

enum class CreationRoute { General, LinkedCall }

data class SearchableSupportCall(
    val callerName: String,
    val callerPhone: String,
    val receivedByName: String,
    val deviceName: String,
)

object CallTicketPolicy {
    fun creationRoute(hasSelectedCall: Boolean): CreationRoute =
        if (hasSelectedCall) CreationRoute.LinkedCall else CreationRoute.General

    fun matchesSearch(call: SearchableSupportCall, search: String): Boolean {
        val needle = search.trim()
        return needle.isBlank() || listOf(
            call.callerName,
            call.callerPhone,
            call.receivedByName,
            call.deviceName,
        ).any { it.contains(needle, ignoreCase = true) }
    }
}
